// extracted by mini-css-extract-plugin
export default {"Footer":"_Footer--CVKIv","Left":"_Left--sa9Tv","Right":"_Right--zzrNJ","Button":"_Button--Mw6Fi","Icon":"_Icon--Lum9S","Active":"_Active--VOHlI","Error":"_Error--EbwcJ"};